import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function PlatformAudit() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/platform/audit").then((r) => setEvents(r.data.events || [])).catch(() => setEvents([]));
  }, []);

  return (
    <div className="px-4 py-5 md:px-8 md:py-6">
      <div className="text-[11px] uppercase tracking-[0.18em] mb-1" style={{ color: "var(--text-muted)" }}>
        Platform
      </div>
      <h1 className="font-display text-[26px]">Staff audit</h1>
      <p className="text-[13px] mt-1" style={{ color: "var(--text-secondary)" }}>
        Every action Prioris staff have taken inside a customer's workspace, newest first.
        Kept separately from each client's own trail and never subject to their retention window.
      </p>

      <div className="card overflow-x-auto mt-5" data-testid="platform-audit">
        <table className="w-full min-w-[640px] text-[13px]">
          <thead>
            <tr className="text-left" style={{ color: "var(--text-muted)", borderBottom: "1px solid var(--border)" }}>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">When</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Who</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Action</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Target</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Reason</th>
            </tr>
          </thead>
          <tbody>
            {events === null && (
              <tr><td colSpan={5} className="py-10 text-center" style={{ color: "var(--text-muted)" }}>Loading…</td></tr>
            )}
            {events?.length === 0 && (
              <tr><td colSpan={5} className="py-10 text-center" style={{ color: "var(--text-muted)" }}>
                Nothing recorded yet.
              </td></tr>
            )}
            {events?.map((e) => (
              <tr key={e.id} style={{ borderBottom: "1px solid var(--border)" }}
                  data-testid={`audit-row-${e.id}`}>
                <td className="py-2.5 px-3 font-mono text-[11.5px]">{e.created_at}</td>
                <td className="py-2.5 px-3">{e.actor_email}</td>
                <td className="py-2.5 px-3 font-mono text-[12px]">{e.action_type}</td>
                <td className="py-2.5 px-3" style={{ color: "var(--text-secondary)" }}>
                  {e.target_type}
                  {e.metadata?.slug && <span className="font-mono ml-1">{e.metadata.slug}</span>}
                </td>
                <td className="py-2.5 px-3" style={{ color: "var(--text-secondary)" }}>{e.reason || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
